import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersOffersApi,
  partnersOffersApiKeys,
} from '@/api/routes/partners/partners.offers.api';
import { partnersCampaignsApiKeys } from '@/api/routes/partners/partners.campaigns.api';

export type PartnerOfferAction = 'submit' | 'archive';

/**
 * Send to review or archive. The API answer (e.g. 409 "Sua conta precisa estar aprovada") goes to
 * the global snackbar; the offer comes back with its new status. Archiving ends live campaigns.
 */
export const usePartnersOfferAction = (action: PartnerOfferAction) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => partnersOffersApi[action](id).then((res) => res.data.offer),
    onSuccess: (offer) => {
      queryClient.setQueryData(partnersOffersApiKeys.detail(offer.id), offer);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: partnersOffersApiKeys.all }),
        action === 'archive'
          ? queryClient.invalidateQueries({ queryKey: partnersCampaignsApiKeys.all })
          : undefined,
      ]);
    },
  });
};
